<template>
  <v-dialog :value="value" persistent max-width="500" @input="$emit('input', $event)">
    <v-card class="custom-card" rounded="0">
      <v-toolbar color="secondary" class="white--text">
        <v-toolbar-title class="font-weight-bold">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="white--text" :disabled="loading" @click="handleClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="text-center py-8 px-6">
        <v-progress-circular :size="75" color="primary" indeterminate class="mb-6"></v-progress-circular>
        <p v-if="message" class="text-body-1 black--text mb-0" style="white-space: pre-line;">
          {{ message }}
        </p>
      </v-card-text>
      <v-card-actions class="justify-center py-4">
        <v-btn color="primary" outlined width="112" :disabled="loading" @click="handleClose">
          {{ $t('cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ParchmentDeliveryBulkImportLoadingDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClose() {
      if (this.loading) return;
      this.$emit("input", false);
      this.$emit("close");
    },
  },
};
</script>

